<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Threads</div>

    <div class="divider"></div>
    <div class="dates">
      <div class="date start-date">
        <div class="text">Start</div>
        <button
          mat-button
          class="icon-btn"
          (click)="startDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #startDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="startDate"
        >
        </lhpe-datepicker>
      </div>
      <div class="date end-date">
        <div class="text">End</div>
        <button
          mat-button
          class="icon-btn"
          (click)="endDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #endDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="endDate"
        >
        </lhpe-datepicker>
      </div>
    </div>
    <div class="divider"></div>
    <div class="tests-toggle">
      <mat-slide-toggle
        color="lightGreen"
        [checked]="includeTests"
        (change)="onIncludeTestsToggle($event.checked)"
      >
        Include tests
      </mat-slide-toggle>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button
      *ngIf="threadData && threadData.length > 0"
      mat-icon-button
      (click)="exportToPdf()"
      matTooltip="Export PDF"
      aria-label="Export PDF"
      style="margin-right: 8px;"
    >
      <svg-icon src="assets/svg/download.svg"></svg-icon>
    </button>
    <button 
      *ngIf="threadData && threadData.length > 0"
      mat-button 
      class="usage-button"
      (click)="navigateToUsage()"
      title="View Usage Report for this date range">
      <span>View Usage</span>
    </button>
  </div>
</div>

<div class="thread-list">
  <div class="container thread-container">
    <div class="summary-stats" *ngIf="threadData.length">
      <div class="stat-card">
        <div class="stat-value">{{ getTotalThreads() | number }}</div>
        <div class="stat-label">Total Threads</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ getTotalWithFeedback() | number }}</div>
        <div class="stat-label">With Feedback</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ getTotalRatings() | number }}</div>
        <div class="stat-label">With Ratings</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ getTotalShares() | number }}</div>
        <div class="stat-label">Total Shares</div>
      </div>
    </div>
    <div class="container-content">
      <div *ngIf="threadData.length; else noDataTemplate">
        <mat-table 
          #threadTable 
          [dataSource]="threadDataSource" 
          matSort 
          class="thread-table">
          
          <ng-container matColumnDef="created_at">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Date</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ formatDate(row.created_at) }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="user_name">
            <mat-header-cell *matHeaderCellDef mat-sort-header>User</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ formatUserName(row.first_name, row.last_name) }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Email</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.email || 'N/A' }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="rating">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Rating</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ formatRating(row.rating) }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="shares">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Shares</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.shares | number }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="device_info">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Device</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ formatDeviceInfo(row) }}</mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row 
            *matRowDef="let row; columns: displayedColumns;"
            (click)="onRowClick(row)"
            class="clickable-row">
          </mat-row>
        </mat-table>

        <mat-paginator 
          [pageSizeOptions]="pageSizeOptions"
          [pageSize]="perPage"
          [length]="totalItems"
          showFirstLastButtons
          (page)="onPageChange($event)">
        </mat-paginator>
      </div>

      <ng-template #noDataTemplate>
        <div class="no-data">
          <p>No threads found for the selected date range.</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<ng-template #pdfDownloadDialog>
  <div style="padding: 16px 18px; min-width: 360px;">
    <h3 style="margin: 0 0 10px 0;">Thread PDF Ready</h3>
    <p style="margin: 0 0 14px 0; color: #858997;">
      Your export has finished. Use the link below to download the PDF.
    </p>
    <a
      [href]="pdfDownloadUrl"
      target="_blank"
      rel="noopener noreferrer"
      style="display: inline-block; margin-bottom: 12px;"
    >
      Download Thread PDF
    </a>
    <div style="text-align: right;">
      <button mat-button mat-dialog-close color="fiord">Close</button>
    </div>
  </div>
</ng-template>
